/*
semsomi AB
Copyright (c) 2016-2021
All rights reserved
*/
let writers = require('./writers.json');

const paramsToEndpoint = (path, params)=>{
  return path+'/?'+Object.entries(params).filter(p=>p[1]).map(e => e.join('=')).join('&');
}

const settingsToParams =(feed)=>{
  if(feed){
    let data = feed.menu.reduce((a,b)=>{
      ['sort', 'view', 'feed', 'product', 'category', 'page','filter'].includes(b.type) && b.selected && b.value && b.value.length>0 ? a[b.type] = b.value : null
      return a
    },{})
    if(feed.lastRequest && feed.lastRequest.query){
      data.q = feed.lastRequest.query
    }
    return data
  }else{
    return {}
  }
}



const imageExists = (image_url)=>{
  try{
    var http = new XMLHttpRequest();
    // http.setRequestHeader('Access-Control-Allow-Origin', '*')
    // console.log('Loading...')
    http.open('HEAD', image_url, false);
    http.send();
    return http.status != 404;
  }catch(e){
    return false
  }

}

const imagesFromYT = (obj)=>{
    if(obj.type==='video'){
      return [1,2,3].map(i=>({
                      "copyright": "Youtube",
                      "width": 640,
                      "description": "Video Screenshot",
                      "weight": 100,
                      "type": "person",
                      "url": `https://img.youtube.com/vi/${obj.id}/maxres${i}.jpg`,
                      "height": 360
                      }))
    }else{
      return []
    }
}




// This is the FINAL function you should use
function extractFacebookInfo(url, valid = ['video', 'post', 'photo', 'reel']) {
// This is the FINAL Facebook regex you should use
const facebookRegex = /https?:\/\/(?:www\.|m\.)?facebook\.com\/(?:([^\/]+)\/(?:posts|videos)\/(\d+)|photo(?:\.php)?\?.*fbid=(\d+)|watch\/?\?.*v=(\d+)|reel\/(\d+)|story\.php\?.*story_fbid=(\d+))/i;
    const match = url.match(facebookRegex);

    if (!match) return null;

    const [, username1, postId, photoId, watchVideoId, reelId, storyId] = match;

    let type, id, username;

    if (reelId) {
        type = 'reel';
        id = reelId;
        username = null;
    } else if (watchVideoId) {
        type = 'video';
        id = watchVideoId;
        username = null;
    } else if (photoId) {
        type = 'photo';
        id = photoId;
        username = null;
    } else if (postId) {
        type = username1.includes('videos') ? 'video' : 'post';
        id = postId;
        username = username1;
    } else if (storyId) {
        type = 'story';
        id = storyId;
        username = null;
    }

    if (valid.includes(type)) {
        return {
            username: username || null,
            id: id,
            type: "facebook",
            url: url
        };
    }

    return null;
}


const urlToObject = (url, valid, corpus)=>{

      let result = null
      let ytRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|live\/|v\/)?)([\w\-]+)(\S+)?$/i
      let twitterRegex = /^\s*https?:\/\/(twitter|x)\.com\/(?:#!\/)?(\w+)\/status(es)?\/(\d+)/i
      let instaRegex = /^\s*https?:\/\/((?:www)\.)?(instagram)\.com\/(\w+?\/)?(p|reel|reels)\/([\w-]+)/i
      let giphyRegex = /^\s*https?:\/\/((?:www)\.)?giphy\.com\/gifs\/(?:[\w-]+-)?([\w]+)/i

      let redditRegex = /^\s*https?:\/\/(?:www\.)?reddit\.com\/r\/([^\/]+)\/comments\/([^\/]+)(?:\/([^\/]+))?/i;
      // let redditRegex = /^\s*https?:\/\/(?:www\.)?reddit\.com\/r\/([^\/]+)\/(?:[^\/]+)\/([^\/]+)/i;

      let tiktokRegex = /^\s*https?:\/\/(?:www\.)?tiktok\.com\/@([\w\.]+)\/video\/(\d+)/i;

      const yociteRegex = /^\s*https?:\/\/(?:www\.)?yocite\.com\/(?:@?([\w.-]+)\/)?q\/([a-z0-9]+)\/?/i;
      // const facebookRegex = /^\s*https?:\/\/(?:www\.)?facebook\.com\/(?:(?:([^\/]+)\/posts\/(\d+))|photo\?fbid=(\d+)|watch\/\?v=(\d+)|reel\/(\d+))(?:\/?(?:\?[^\/\s]*)?)?\s*$/i;

      // const facebookRegex = /^\s*https?:\/\/(?:www\.)?facebook\.com\/(?:(?:([^\/]+)\/posts\/(\d+))|photo\?fbid=(\d+)|watch\/\?v=(\d+)|reel\/(\d+)(?:\/?\?.*)?)\s*$/i;
      // let facebookRegex = /^\s*https?:\/\/(?:www\.)?facebook\.com\/(?:(?:([^\/]+)\/posts\/(\d+))|photo\?fbid=(\d+)|watch\/\?v=(\d+))/i;

      // let facebookRegex = /^\s*https?:\/\/(?:www\.)?facebook\.com\/(?:(?:([^\/]+)\/posts\/(\d+))|photo\?fbid=(\d+)|watch\/\?v=(\d+))/i;
      // let facebookRegex = /^\s*https?:\/\/(?:www\.)?facebook\.com\/(?:(?:([^\/]+)\/posts\/(\d+))|photo\?fbid=(\d+))/i;
      // let facebookRegex = /^\s*https?:\/\/(?:www\.)?facebook\.com\/([^\/]+)\/posts\/(\d+)/i;
      // let spotifyRegex = /^\s*https?:\/\/(?:open\.)?spotify\.com\/track\/([A-Za-z0-9]+)(?:[\/?].*)?$/i;
      let spotifyRegex = /^\s*https?:\/\/(?:open\.)?spotify\.com\/(?:track|album|playlist|episode|show)\/([A-Za-z0-9]+)(?:[\/?].*)?$/i;
      const polymarketRegex = /^\s*https?:\/\/(?:www\.)?polymarket\.com\/(([^/?#]+)(?:\/[^/?#]+)*?)\/?([?#].*)?$/i;


      // let linkedinRegex =
      //   /^\s*https?:\/\/(?:[\w-]+\.)?linkedin\.com\/(?:posts|feed\/update)\/(?:[^/?#]+-)?activity-(\d+)(?:-[^/?#]+)?\/?/i;

      // console.log(url)

      let ytRes = ytRegex.exec(url)
      let resX = twitterRegex.exec(url)
      let instaX = instaRegex.exec(url)
      let giphy = giphyRegex.exec(url)
      let redditRes = redditRegex.exec(url);
      let tiktokRes = tiktokRegex.exec(url);
      let spotifyRes = spotifyRegex.exec(url);
      let yocite = yociteRegex.exec(url);
      let polymarketRes = polymarketRegex.exec(url);
      // let facebookRes = facebookRegex.exec(url);
      // console.log(valid)
      let faceBook = extractFacebookInfo(url, ['video', 'post', 'photo', 'reel'])

      // console.log(spotifyRes)
      if(faceBook){
        return faceBook
      }else if(ytRes && ytRes[6] && valid.includes('video')){
          result = {
            "thumbnail": "https://img.youtube.com/vi/"+ytRes[6]+"/0.jpg",
            "id": ytRes[6],
            "sourceName": "Youtube",
            "type": "video",
            "url": "https://www.youtube.com/embed/"+ytRes[6],
            "quality": 1
          }
      // } else if (facebookRes && (facebookRes[2] || facebookRes[3] || facebookRes[4]) && valid.includes('video')) {
      //     result = {
      //         "username": facebookRes[1] || null,
      //         "id": facebookRes[2] || facebookRes[3] || facebookRes[4],
      //         "type": "facebook",
      //         "url": url
      //     };
      }else if (polymarketRes && polymarketRes[1] && valid.includes('polymarket')) {
        const parts = polymarketRes[1].split('/');
        const embedPath = parts.length > 2 ? parts[0] : 'market';
        const slug = parts.at(-1);
        result = {
          id: slug,
          type: 'polymarket',
          url: `https://embed.polymarket.com/${embedPath}?market=${slug}&theme=dark&height=300`
        };
      }else if (spotifyRes && spotifyRes[1] && valid.includes('video')) {

          result = {
              "id": spotifyRes[1],
              "type": "spotify",
              "url": url
          };
      } else if (tiktokRes && tiktokRes[1] && tiktokRes[2] && valid.includes('video')) {
          result = {
              "username": tiktokRes[1],
              "id": tiktokRes[2],
              "type": "tiktok",
              "url": url
          };
      }else if (redditRes && redditRes[1] && redditRes[2] && valid.includes('video')) {
          result = {
              "username": redditRes[1],
              "id": redditRes[2],
              // "slug": redditRes[3] || null,
              "type": "reddit",
              "url": url
          };
      }else if(giphy && giphy[2] && valid.includes('video')){
          result = {
              "copyright": "Giphy",
              "width": 480,
              "description": "via GIPHY",
              "weight": 10,
              "type": "video",
              "url": "https://giphy.com/embed/"+giphy[2],
              "height": 270,
              "source": "Giphy",
              "thumbnail": `https://media2.giphy.com/media/${giphy[2]}/giphy.gif`
          }
      }else if (yocite && yocite[2] && valid.includes('yocite')) {
      // console.log(yocite)
       result = {
         "weight": 1,
         "id": yocite[2],           // quote id
         "username": yocite[1] || null, // author slug if present
         "type": 'yocite',
         "url":url
       };
     }else if(resX && resX[4] && valid.includes('twitter')){
          result = {
            "weight": 1,
            "id": resX[4],
            "avatar": "https://twitter.com/"+resX[2]+"/profile_image?size=bigger",
            "type": "twitter",
            "url": url,
            "username": resX[2]
          }
      }else if(instaX && instaX[5] && valid.includes('instagram')){
          result = {
            "weight": 1,
            "id": instaX[5],
            // "avatar": "https://twitter.com/"+resX[2]+"/profile_image?size=bigger",
            "type": "instagram",
            "url": url,
            // "username": instaX[2]
          }
      }else if(valid.includes('image')){
        let urlObj =  new URL(url)

        let exists = imageExists(url)

        if(!exists){

          url = "https://www.writer.monok.com/api/v1/fx12ha7sjs8djs54?url=" + encodeURIComponent(url)
          // url = "http://dev.com/api/v1/fx12ha7sjs8djs54?url=" + url
          // url = window.location.origin + config.server[window.env].apiUrl + "fx12ha7sjs8djs54?" + "url=" + url
          exists = imageExists(url)
        }

        if(exists){
          result = {
            "data": [
              {
              "image": {
                "copyright":urlObj ? urlObj.hostname : 'Unknown source',
                "width": 110,
                "description": urlObj && corpus ? urlObj.href.replace(urlObj.host, '').split(/[\b\W_]/)
                // .map(s=>{
                //   console.log(s)
                //   return s
                // })
                .filter((word,i,arr)=>arr.indexOf(word)===i && !word.match(/\W/) && corpus.toLowerCase().includes(word.toLowerCase())).join(' ') : "Stock Photo",
                "type": "person",
                "url": url,
                "height": 218
              },
              "description": "Stock Photo"
              }
            ],
            "name": "Stock Photo",
            "type": "person"
          }
        }
      }

      // console.log(result)
      return result
}


const setting = (tags, prefix, def)=>{
  let val = tags ? tags.find(setting=>setting && ((setting.value && setting.value.startsWith(prefix+':')) || (typeof setting === 'string' && setting.startsWith(prefix+':')))) : null
  val = val && val.value ? val.value : val
  if(['enabled','true','yes'].includes(val)){
    return true
  }else if(['disabled','false','no'].includes(val)){
    return false
  }
  let number = val && !val.includes('|') ? parseInt(val.split(':')[1]) : null
  return val ? ((number || number===0) ? number : val.split(':')[1]) : def
}

const getLocation = (article)=>{
    var text = null
    if(article.place && article.place.data && article.place.data[0] && article.place.data[0].description){
      var place = article.place.data[0]
      text = place.text ? place.text : place.description

      if(text.includes(',')){
        var temp = text.split(',')
        text = temp[0]+", "+temp[temp.length-1]
        if(text.length>13){
          text = temp[temp.length-1]
        }
      }

      text = text.replace(/\([^\()]+\)/,'')

      if(place.text && text.length>20){
        text = place.text
      }

    }else if(article.place && article.place.name){
      //New Method

      text = article.place.name
    }

    if(text && text.length<20){
      return text
    }else{
      return null
    }

}

  const translateRate = (rate)=>{
    if(rate>999999){
      rate = (Math.round(rate / 100000) / 10).toString()
      return rate+'M'
    }
    if(rate>9999){
      return rate.toString().slice(0,rate.toString().length-3) + 'K'
    }
    if(rate>1000){
      return Math.round(rate /100)/10 + 'K'
    }
    return rate
  }

  const timeAge = (date)=>{
    return Math.abs(new Date().getTime() - new Date(date).getTime());
  }

  const hoursOld = (date)=>{
    return Math.ceil(timeAge(date) / (1000 * 3600));
  }

  const daysOld = (date)=>{
    return Math.ceil(timeAge(date) / (1000 * 3600 * 24));
  }

  const addQuoteImages=(article)=>{
    let getImage = (widget)=>{
      return widget && widget.data && widget.data[0] && widget.data[0].image ?  widget.data[0].image : null
    }

    let qq = []
    if(article.quotes){
      article.quotes.forEach(quote=>{
        if(qq.filter(q=>q.speaker===quote.speaker).length<1){
          qq.push(quote)
        }
      })
    }

    let qImages = qq.map(quote=>{

        let collage = article && article.widgets ? article.widgets.filter(widget=>
                                                    {
                                                      let image = getImage(widget)

                                                      // console.log(quote)
                                                      // if(widget.name && widget.type==='person' && image && image.width<image.height && article &&
                                                      //        quote.speaker.toLowerCase().includes(widget.name.toLowerCase())){
                                                      //   console.log(widget)
                                                      // }

                                                      return widget.name && widget.type==='person' && image && image.width<image.height && article &&
                                                             quote.speaker && quote.speaker.toLowerCase().includes(widget.name.toLowerCase())
                                                    }).slice(0,1).map(widget=>{
                                                      let image = getImage(widget)
                                                      return {url:image.url, description:widget.name}
                                                    }) : null
        if(collage && collage.length>0){
          let secondImage = article.images.filter(image=>!collage.find(img=>img.url===image.url) && image.copyright!=='Youtube').sort((a,b)=>{
            let aR = a.width/a.height
            let bR = b.width/b.height
            return bR - aR
          })[0]
          collage[0].class='darkQuote photoQuote'
          collage[0].text = quote.text
          collage[0].speaker = quote.speaker
          collage.push({...secondImage, class:'darkQuote', description:'widget.name'})//, text:quote.text, speaker:quote.speaker
            try{
              let encoded = JSON.stringify(collage).encode()
              return {type:'collage', url: collage[0].url, encoded:encoded, description:'' + collage[0].description+ ' says '+quote.text + ' via ' +quote.pubName}
            }catch(e){
              console.log(e)
            }

        }
    }).filter(im=>im)


    if(qImages.length>0){
      // article.visualFocus = {type:"collage", name:"stock",data:[{image:qImages[0]}]}

      // article.images = qImages.concat(article.images)

    }
    return qImages
  }



  const addCollage=(article)=>{
    let getImage = (widget)=>{
      return widget && widget.data && widget.data[0] && widget.data[0].image ?  widget.data[0].image : null
    }
    let collages = []
    let collage = article && article.widgets ? article.widgets.filter(widget=>
                                                                {
                                                                  let image = getImage(widget)
                                                                  return widget.name && widget.type==='person' && image && image.width<image.height && article &&
                                                                        (article.sources.find(source=>source.title.toLowerCase().includes(widget.name.toLowerCase())) ||
                                                                        (article.title && article.title.toLowerCase().includes(widget.name.toLowerCase())))
                                                                }).slice(0,2).map(widget=>{
                                                                  let image = getImage(widget)
                                                                  return {url:image.url, description:widget.name}
                                                                }) : null
    // console.log(collage)
    if(collage && collage.length>1){
      let coll = {type:'collage', url: collage[0].url, encoded:JSON.stringify(collage).encode(), description:'Left: ' + collage[0].description + ', Right: ' + collage[1].description}
      collages.push(coll)
      // article.visualFocus = coll //do this
      // article.visualFocus = {type:"collage", name:"stock",data:[{image:coll}]}
    }

    // console.log(article.images)
    return collages
  }

const addLogoImages=(article)=>{
     let getImage = (widget)=>{
      return widget && widget.data && widget.data[0] && widget.data[0].image ?  widget.data[0].image : null
    }
    let collages = []
    let collage = article && article.widgets ? article.widgets.filter((widget, i, arr)=>
                                                                {
                                                                  let image = getImage(widget)
                                                                  return image && arr.findIndex(oW=>getImage(oW) && getImage(oW).url.replace(/\d+px/g,'')===image.url.replace(/\d+px/g,''))===i &&
                                                                        widget.name && ['organization'].includes(widget.type) && image.description && image.description.toLowerCase().includes('logo') && (image.url.includes('.png') || image.url.includes('.svg')) && article &&
                                                                        (article.sources.find(source=>source.title.toLowerCase().split(' ').some(r=> widget.name.toLowerCase().split(' ').indexOf(r) >= 0)) ||
                                                                        (article.title && article.title.toLowerCase().includes(widget.name.toLowerCase())))
                                                                }).slice(0,2).map((widget,i)=>{
                                                                  let image = getImage(widget)
                                                                  // console.log(image)
                                                                  if(i===0){
                                                                    let backgroundUrl = article.images ? article.images.find(image=>image.width && image.height && image.width/image.height>1.3 && image.copyright!=='Youtube') : null
                                                                    return {url:image.url, class:'logoImage', description:widget.name, background:backgroundUrl ? backgroundUrl.url : undefined}
                                                                  }
                                                                  return {url:image.url, class:'logoImage', description:widget.name}
                                                                }) : null
    // console.log(collage)
    if(collage && collage.length>1){
      let coll = {type:'collage', url: collage[0].url, encoded:JSON.stringify(collage).encode(), description:'Left: ' + collage[0].description + ', Right: ' + collage[1].description}
      collages.push(coll)
      // article.visualFocus = coll //do this
      // article.visualFocus = {type:"collage", name:"stock",data:[{image:coll}]}
    }

    // console.log(article.images)
    return collages
  }

export {addLogoImages, addQuoteImages, addCollage, paramsToEndpoint, settingsToParams, getLocation, setting, daysOld, hoursOld, urlToObject, imagesFromYT, translateRate}
